module.exports = __webpack_public_path__ + "img/estimationicon.81de473a.svg";